import ICONS from "./iconUtils";

const FRONTEND_URL =
  process.env.NEXT_PUBLIC_FRONTEND_URL ||
  "https://login-area-8183d04fd47f.herokuapp.com";

function getSentryEnvironment(): string {
  if (FRONTEND_URL.startsWith("http://localhost")) {
    return "local";
  }
  if (process.env.APP_ENV === "development") {
    return "staging";
  }
  return "production";
}

const CONSTS = {
  API_URL: process.env.NEXT_PUBLIC_API_URL || "http://localhost:4000/api",
  CK_LANDING_PAGE_URL: "https://www.cleverklagen.de",
  FRONTEND_URL,
  SUPABASE_URL: process.env.NEXT_PUBLIC_SUPABASE_URL || "",
  SUPABASE_ANON_KEY: process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY || "",
  IS_DEV: process.env.APP_ENV === "development",
  IS_LOCAL: FRONTEND_URL.startsWith("http://localhost"),
  IS_PRODUCTION: process.env.NEXT_PUBLIC_APP_ENV === "production",
  SENTRY_ENVIRONMENT: getSentryEnvironment(),
  COLORS: {
    PRIMARY_BLUE: "#2906c6",
    SECONDARY_BLUE: "#2205a5",
    DARK_BLUE: "#150363",
    GREEN: "#a7f9af",
    YELLOW: "#fdf4be",
    GREY: "#ecece5",
    WHITE: "#ffffff",
  },
  ICONS,
};

if (
  process.env.NODE_ENV !== "production" &&
  (!CONSTS.SUPABASE_URL || !CONSTS.SUPABASE_ANON_KEY)
) {
  console.warn(
    "[config] Missing Supabase env vars: " +
      `NEXT_PUBLIC_SUPABASE_URL=${CONSTS.SUPABASE_URL ? "set" : "MISSING"}, ` +
      `NEXT_PUBLIC_SUPABASE_ANON_KEY=${
        CONSTS.SUPABASE_ANON_KEY ? "set" : "MISSING"
      }. ` +
      "Auth will fail until these are set in service-area/.env (then restart next dev)."
  );
}

export default CONSTS;
